import { computed, ref } from 'vue';

export function useListData(goalListService, renderedItemsLimit, loaderSvc) {
  const renderedItems = ref(renderedItemsLimit.value);
  const goalList = computed(() => goalListService.goalList.value.slice(0, renderedItems.value));

  const hasMore = computed(() => goalListService.goalList.value.length > renderedItems.value);
  const loadMore = () => {
    renderedItems.value += renderedItemsLimit.value;
    if (hasMore.value) {
      return;
    }
    loaderSvc.loadMore();
  };

  return { goalList, loadMore, hasMore: computed(() => hasMore.value || loaderSvc.hasMore.value) };
}
